import { CharacteristicValue } from '@/models/references-classification/characteristic-value';

export class Characteristic {
    public id: number = 0;
    public businessId: number = 0;
    public name?: string;
    public values: CharacteristicValue[] = [];

    get value(): number {
        return this.id;
    }

    get text(): string | undefined {
        return this.name;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            values: json.values
                ? json.values.map((value: any) => new CharacteristicValue(value))
                : [],
        });
    }

    public clone(): Characteristic {
        const characteristic = new Characteristic();

        characteristic.id = this.id;
        characteristic.businessId = this.businessId;
        characteristic.name = this.name;
        characteristic.values.push(...this.values.map((value) => value.clone()));

        return characteristic;
    }
}
